export default __webpack_public_path__ + "static/media/earnlogo.f41da75c.svg";